import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "FDA 510(k) CLEARED",
  "ISO 7 CERTIFIED CLEANROOM",
  "PRIVATE LABEL MANUFACTURING",
  "ISO 14644-1:2015",
  "cGMP ALIGNED",
  "FULL DOCUMENTATION PACKAGE",
];

export const Ribbon = ({ dark = false }) => (
  <div
    className={`border-y ${
      dark ? "border-white/10 bg-navy" : "border-slate-200 bg-mist"
    } py-5`}
    data-testid="editorial-ribbon"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <span
          key={i}
          className={`mx-8 inline-flex items-center gap-8 text-sm font-semibold uppercase tracking-[0.28em] ${
            dark ? "text-slate-400" : "text-slate-500"
          }`}
        >
          {t}
          <span className={`h-1 w-1 ${dark ? "bg-clinical" : "bg-clinical"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);

export default Ribbon;
